import { Chip, styled } from '@/core/ui';
/**
 * Minimal width of the chip, as a `theme.spacing()` argument.
 */
const quantityChipMinWidthSpacingArgument = 9;
export const ChipStyled = styled(Chip)(({ theme }) => ({
    minWidth: theme.spacing(quantityChipMinWidthSpacingArgument),
    fontSize: theme.typography.caption.fontSize,
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
}));
